import {useSelector} from "react-redux";
import {RootSliceType} from "redux/reducers/rootReducer";
import {IPayment} from "../reducers/expertPaymentHistorySlice";

const useExpertPaymentSelectors = () => {
  const paymentHistory = useSelector<RootSliceType, IPayment["paymentHistory"]>(
    (state) => state.paymentHistory.paymentHistory
  );

  const loading = useSelector<RootSliceType, IPayment["loading"]>(
    (state) => state.paymentHistory.loading
  );
  return {
    paymentHistory,
    loading
  };
};

export default useExpertPaymentSelectors;